module.exports = __webpack_public_path__ + "img/SES_205331200.85e29178.jpg";